import React from 'react';
import { observer } from 'mobx-react-lite';
import Button from 'ati-ui-react/components/Button';
import getEnvironDomain from 'utils/getEnvironDomain';
import linkCheckId from 'utils/linkCheckId';
import { useStores } from 'hooks/useStores';
import { AllHistoryButtonStyles } from './AllHistoryButtonStyles';
import checkIcon from '../img/check.svg';

const checkId = '232221ab-4fa1-498b-9741-0e990cd3a754';
const cost = 239;

const AllHistoryButton = observer(() => {
  const {
    advertsStore: { currentAdvert },
  } = useStores();

  // TODO: убрать после перевода сторов на TS
  // @ts-ignore
  const advertItems = currentAdvert?.advert_items;
  // @ts-ignore
  const advertItem = currentAdvert?.advert_item;

  const renderLink = () => {
    if (advertItems) {
      return linkCheckId(checkId, advertItems[0]?.transport.vin, advertItems[0]?.transport.gov_num);
    }
    return linkCheckId(checkId, advertItem?.vin, advertItem?.gov_num);
  };

  return (
    <AllHistoryButtonStyles>
      <div className="text-container">
        <img src={checkIcon} alt="Truckmarket" className="check-icon" />
        <span className="text">Вся история ТС</span>
      </div>
      <Button
        size="small"
        primary={false}
        className="button"
        href={`//${getEnvironDomain()}/verification/${renderLink()}`}
        target="_blank"
      >
        Купить отчет за {cost} ат.
      </Button>
    </AllHistoryButtonStyles>
  );
});

export default AllHistoryButton;
